export default "__VITE_ASSET__DdD4_$OP__"